module.exports = __webpack_public_path__ + "img/bg-dot60.574bbaf.png";